<div class="dialog-header" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
    <div class="header-side"></div>
    <div class="dialog-title-text" cdkDragHandle>
      Edit Internal Notes for {{title}}
    </div>
    <button mat-icon-button class="close-btn" (click)="onClose()">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content class="mat-typography">
    <mat-form-field appearance="outline" class="form-field-item small flex-100" style="width: 100% !important;">
      <mat-label>Notes</mat-label>
      <textarea matInput [(ngModel)]="notes" data-testid="notes" required maxlength="3000" rows="4" style="width:100% !important;"></textarea>
    </mat-form-field>
  </mat-dialog-content>
  <mat-dialog-actions align="end" class="dialog-footer">
    <button data-testid="btnClose" mat-raised-button color="primary" mat-primary (click)="onClose()">Cancel</button>
    <button data-testid="btnSave" mat-raised-button color="primary" mat-primary (click)="onSave()">Save</button>
  </mat-dialog-actions>